import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeResult } from "@/components/companion/KnowledgeResult";

export const Route = createFileRoute("/knowledge/$kbId")({
  component: KnowledgeDetail,
});

function KnowledgeDetail() {
  const { kbId } = Route.useParams();
  return <KnowledgeResult kbId={kbId} />;
}
